export default __webpack_public_path__ + "static/bitcoin-82491fef997ab841639c640dd60a040f.png";